"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBreakpoint = void 0;
var styles_1 = require("../styles");
var useWindowSize_1 = require("./useWindowSize");
/**
 * Current applied breakpoint, based on window's width.
 *
 * Note: it might return `null` on first render, if `window` object
 * is not defined (on server side rendering, for example).
 */
function useBreakpoint() {
    var theme = styles_1.useTheme();
    var dimensions = useWindowSize_1.useWindowSize();
    if (!dimensions) {
        return null;
    }
    var sizes = ['xl', 'lg', 'md', 'sm', 'xs'];
    var current = sizes.find(function (key) { return dimensions.innerWidth > theme.breakpoints.size[key]; });
    return current;
}
exports.useBreakpoint = useBreakpoint;
//# sourceMappingURL=useBreakpoint.js.map